export default __webpack_public_path__ + "static/media/home_portfolios_form.bed6d575.jpg";